const defaultState: any = null;

const currentWorkspaceReducer = (state = defaultState, action: { type: string; payload: any }) => {
	switch (action.type) {
		case 'SET_CURRENT_WORKSPACE':
			return action.payload;

		default:
			return state;
	}
};

export default currentWorkspaceReducer;
